import React from 'react';
import { ApiContext } from '../context.js';
import PropTypes from 'prop-types';
export default function TablistView(deps, props) {
  var _deps = deps(React.useContext(ApiContext)),
    tablistViewPropsManager = _deps.tablistViewPropsManager;
  return /*#__PURE__*/React.createElement("div", tablistViewPropsManager(), props.children);
}